import { useEffect } from "react";
import { useConsentService } from "@aviv-csnt/react";

import { useOverlayOrchestrator } from "../../createOverlayOrchestratorContext";
import { useUserConsent } from "../../../../utils/consentManagement";

const KEY = "consent";

/**
 * Ensures that the Usercentrics root element has the attribute
 * `data-react-aria-top-layer="true"` so that React Aria can
 * properly manage focus for overlays.
 * See https://github.com/adobe/react-spectrum/issues/8784#issuecomment-3415368636
 */
const applyReactAriaAttribute = () => {
  const el = document.querySelector("#usercentrics-root");

  if (el) {
    el.setAttribute("data-react-aria-top-layer", "true");
    el.removeAttribute("inert");
  }
};

export const useInitConsent = () => {
  const isUserConsent = useUserConsent();
  const { isInitialized } = useConsentService();
  const { dispatch } = useOverlayOrchestrator();

  useEffect(() => {
    if (isInitialized) {
      applyReactAriaAttribute();
    }
  }, [isInitialized]);

  useEffect(() => {
    if (isUserConsent) {
      dispatch({ type: "COMPLETE", payload: KEY });
    }
  }, [dispatch, isUserConsent]);
};
